(() => {
  window.addEventListener("abra:announced", () => {
    document
      .querySelectorAll(".multi-collection__tab-group button")
      .forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("abra:render"));
          }, 500);
        });
      });
  });

  const customer = fetchCustomer();

  if (
    customer &&
    customer.tags &&
    customer.tags.length > 0 &&
    customer.tags.includes("Trade")
  ) {
    window.Abra.deactivate(false);
  }

  function fetchCustomer() {
    try {
      const scriptElement = document.getElementById("AbraCustomer");

      if (scriptElement && scriptElement.textContent) {
        try {
          return JSON.parse(scriptElement.textContent);
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }

    return undefined;
  }
})();
